import { render, staticRenderFns } from "./MitDataTable.vue?vue&type=template&id=24590f5a&scoped=true"
import script from "./MitDataTable.vue?vue&type=script&lang=js"
export * from "./MitDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24590f5a",
  null
  
)

export default component.exports